import React, {useState} from "react";  
import {FaArrowRight, FaArrowLeft} from 'react-icons/fa'



import './PropertiesCard.css'

function PropertiesCard(props){
    const { images } = props

    const [current,setCurrent] = useState(0)
    const length = images.length

    const nextImage = () =>{
        setCurrent(current === length - 1 ? 0 : current + 1)
    }

    const prevImage = () => {
        setCurrent(current === 0 ? length - 1 : current - 1)
    }

    return(
        <>
        <div className="propertyCard">
       
        <FaArrowLeft className="leftArrow" onClick={prevImage} />
            
            {images.map((imgUrl, index) => (
                <div className={index === current ? 'slide active' : 'slide'} key={index}>
                    {index === current && (
                    <img key={index} 
                    src={process.env.PUBLIC_URL + imgUrl} alt ="home" 
                    className="propertyImage"
                    type="image/jxr"
                    />)}
                    
                </div>
        ))}
        <FaArrowRight className= "rightArrow" onClick={nextImage} />
        </div>
        </>
    );
}

export default PropertiesCard;